import { Box } from '@rsos/base-components';
import CallChats from '../../CallChats/CallChats';
import OverviewBanners from './OverviewTab/OverviewBanners';

const ChatsTab = () => {
  return (
    <Box gridRowGap="16px" height="100%">
      <OverviewBanners />
      <CallChats />
    </Box>
  );
};

export default ChatsTab;
